import React, { useContext } from "react";
import Button from "@atoms/Button/Button";
import { generateLinkWithExternalParams } from "../../helpers/linkHelpers";
import { GlobalContext } from "@context/GlobalContext";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { AnalyticsEventType } from "../../context/TrackingProvider";
import { useTracking } from "../../hooks";
import { isEmpty } from "lodash";
interface Cta {
	ctaLabel?: string;
	ctaUrl?: string;
	ctaProps?: any;
	ctaAnchorLink?: string;
}

interface Props {
	cta: Cta;
	queryParam?: string;
	trackingInfo?: any;
}

const CommonActionButton: React.FC<Props> = ({ cta, queryParam = "", trackingInfo = {} }) => {
	const [globalState] = useContext(GlobalContext);
	const { track } = useTracking();

	if (cta?.ctaAnchorLink) {
		return (
			<AnchorLink offset={() => 120} href={cta?.ctaAnchorLink}>
				<Button
					align="center"
					theme="pink-gradient"
					{...cta.ctaProps}
					label={cta.ctaLabel}
				/>
			</AnchorLink>
		);
	}

	const href = generateLinkWithExternalParams(
		`${cta.ctaUrl}/${queryParam}`,
		globalState.apySrc,
	);

	const handleClick = () => {
		if (!isEmpty(trackingInfo)) {
			track({
				eventType: AnalyticsEventType.GButtonClick,
				data: {
					sourceUrl: window.location.pathname,
					targetUrl: href,
					...trackingInfo,
				},
			});
		}
	};

	return (
		<a
			href={href}
			target="_blank"
			rel="noreferrer"
			onClick={handleClick}
		>
			<Button
				align="center"
				theme="pink-gradient"
				{...cta.ctaProps}
				label={cta.ctaLabel}
			/>
		</a>
	);
};

export default CommonActionButton;
